import { Time } from '@instinet-analytics/core-lib';

export interface VolumeCurveComponentState {
    startTime?: Time;
    endTime?: Time;
}

export const initialVolumeCurveComponentState: VolumeCurveComponentState = {};
